<template>
  <div class="nav__mega__wrapper">
    <div class="nav__mega__container">
      <input
        :id="menu.id"
        type="radio"
        name="mega-nav"
        class="nav__mega__trigger"
      >
      <div class="nav__mega">
        <!-- <div class="nav__mega__overview">
          <div class="grid">
            <div class="col">
              <router-link v-if="menu.route !== undefined"
                           class="nav__mega__overview__link"
                           :to="menu.route"                       
                           :title="menu.title"
              >
                {{ menu.title }}
                <v-icon color="primary" large>
                  mdi-chevron-right
                </v-icon>                 
              </router-link>    
              <a v-else-if="menu.link !== undefined"
                 class="nav__mega__overview__link"
                 :href="menu.link"                  
              >
                {{ menu.title }}   
                <v-icon color="primary" x-large>
                  mdi-chevron-right
                </v-icon>                 
              </a>                        
            </div>
          </div>
        </div> -->
        <div class="nav__mega__content">
          <div class="grid grid--stretch">
            <div class="col col--md-12">
              <ul class="nav__mega__items">
                <li v-for="(menuItem,index) in menu.children" :key="index" class="nav__mega__item">
                  <router-link v-if="menuItem.route !== undefined"
                               class="nav__mega__item__link"
                               :to="menuItem.route"                       
                               :title="menuItem.title"
                  >
                    {{ menuItem.title }}
                    <v-icon color="primary" dense>
                      mdi-chevron-right
                    </v-icon> 
                  </router-link>    
                  <a v-else-if="menuItem.link !== undefined"
                     class="nav__mega__item__link"
                     :href="menuItem.link"                  
                  >
                    {{ menuItem.title }}   
                    <v-icon color="primary" dense>
                      mdi-chevron-right
                    </v-icon>   
                  </a>                                              
                  <ul v-if="menuItem.children !== undefined"
                      class="nav__mega__children-items" 
                  >
                    <li v-for="(menuItemChlid,childIndex) in menuItem.children" :key="childIndex" class="nav__mega__item">
                      <router-link v-if="menuItemChlid.route !== undefined"
                                   class="nav__mega__item__link"
                                   :to="menuItemChlid.route"                       
                                   :title="menuItemChlid.title"
                      >
                        {{ menuItemChlid.title }}
                        <v-icon color="primary" dense>
                          mdi-chevron-right
                        </v-icon>   
                      </router-link>    
                      <a v-else-if="menuItemChlid.link !== undefined"
                         class="nav__mega__item__link"
                         :href="menuItemChlid.link"                  
                      >
                        {{ menuItemChlid.title }}   
                        <v-icon color="primary" dense>
                          mdi-chevron-right
                        </v-icon>   
                      </a>                             
                      <span v-else>
                        {{ menuItemChlid.title }}
                        <v-icon color="primary" dense>
                          mdi-chevron-right
                        </v-icon>  
                      </span>          
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name:'NavigationMegaItem',
  props: {
    menu: {
      type: Object,
      required: true,
    }
   
  },   
}

</script>
